import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '8px',
    cursor: 'pointer',

    '& > *': {
      outline: 'none',
      border: 'none',

      [theme.breakpoints.up('sm')]: {
        height: '100%'
      }
    },

    '& .text': {
      overflow: 'auto !important',
      width: '100%',
      backgroundColor: 'transparent',
      color: '#323436',
      resize: 'none',

      [theme.breakpoints.down('md')]: {
        marginBottom: '1.5rem'
      },

      '& div > div > textarea.text__input': {
        padding: '0.25rem 1.25rem 0.25rem 0rem !important',
        overflow: 'hidden !important',
        fontSize: `${theme.size.sm} !important`
      },

      '& div > div > .text__highlighter': {
        height: 'auto !important'
      },

      '& div > .text__control ': {
        height: 'auto !important'
      }
    }
  }
}))

export default useStyles
